import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pgs__info-wrap" }
const _hoisted_2 = { class: "pgs__info_label-item" }
const _hoisted_3 = { class: "pgs__info_text" }

import { IonCol } from '@ionic/vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'PgsInfo',
  props: {
	type: {
		type: String,
		default: 'red',
	},
	label: {
		type: String,
		default: 'Label',
	},
	info: {
		type: [String, Number],
		default: '',
	},
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCol), {
    class: _normalizeClass(["pgs__info", `pgs__info--${__props.type}`])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(__props.label), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.info), 1)
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})